var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNextsong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    fill: "#3751fe",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.3,200c-1.5,0-2.9-0.4-4.1-1.1c-2.5-1.5-4.1-4.2-4.1-7.2V8.4c0-2.9,1.6-5.7,4.1-7.2c2.5-1.5,5.7-1.5,8.2,0 l158.8,91.6c2.5,1.5,4.1,4.2,4.1,7.2s-1.6,5.7-4.1,7.2L21.5,198.8C20.2,199.6,18.7,200,17.3,200L17.3,200z M25.6,22.7v154.6 L159.5,100C159.5,100,25.6,22.7,25.6,22.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.3,200c-5.7,0-10.3-4.6-10.3-10.3V10.3c0-5.7,4.6-10.3,10.3-10.3c5.7,0,10.3,4.6,10.3,10.3v179.2 C190.6,195.4,186,200,180.3,200L180.3,200z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNextsong);
export default __webpack_public_path__ + "static/media/ico-nextsong.442ccf9211964f026a371dc7c0c2039e.svg";
export { ForwardRef as ReactComponent };